import { render, staticRenderFns } from "./BaseMultiCheckboxInput.vue?vue&type=template&id=3be8a10a"
import script from "./BaseMultiCheckboxInput.vue?vue&type=script&lang=js"
export * from "./BaseMultiCheckboxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports